import { useState } from 'react';

import { IconAngleRight } from '@iwoca/icons';
import { Link } from '@iwoca/orion';

import BankConnectionStep from './BankConnectionStep';
import BankSelectionStep from './BankSelectionStep';
import styles from './LinkBankAccount.module.css';
import { useTruelayerAuthorizationMutation } from '../../../../../api/openBankingLinkApi/usePostTruelayerProviderAuthorizationMutation';
import { useContextStateKey } from '../../../../../hooks/useContextStateKey';
import { TOnlineBank } from '../../../OpenBanking/OpenBanking.types';
import { TLinkedBankAccount } from '../../../OpenBanking/trueLayer.helpers';
import TrueLayerLinkedAccount from '../../../OpenBanking/TrueLayerLinkedAccount/TrueLayerLinkedAccount';

enum onlineBankSelection {
  BANK_LIST = 'bankList',
  BANK_CONNECTION = 'bankConnection',
}

type TProps = {
  linkedBankAccount?: TLinkedBankAccount[];
};

const LinkBankAccount = ({ linkedBankAccount }: TProps) => {
  const [view, setView] = useState<onlineBankSelection>(
    onlineBankSelection.BANK_LIST,
  );
  const [selectedBank, setSelectedBank] = useState<TOnlineBank | null>(null);
  const [showBankSelection, setShowBankSelection] = useState(false);

  const stateKey = useContextStateKey();
  const { postBankAuthentication, bankAuthUrl, isError, resetURL } =
    useTruelayerAuthorizationMutation();

  const hasLinkedAccounts = linkedBankAccount && linkedBankAccount.length > 0;

  const handleBankSelect = (bank: TOnlineBank) => {
    if (!stateKey || !bank.provider) return;

    setSelectedBank(bank);
    setView(onlineBankSelection.BANK_CONNECTION);

    postBankAuthentication({
      stateKey,
      providerId: bank.bank_id,
    });
  };

  const handleBackClick = () => {
    resetURL();
    setView(onlineBankSelection.BANK_LIST);
  };

  const handleClose = () => {
    resetURL();
    setView(onlineBankSelection.BANK_LIST);
  };

  const shouldShowLinkOpenBankingSplitTest =
    !hasLinkedAccounts || showBankSelection;

  return (
    <>
      {hasLinkedAccounts && (
        <div className={styles.linkedAccountWrapper}>
          <TrueLayerLinkedAccount linkedBankAccount={linkedBankAccount} />
        </div>
      )}
      {hasLinkedAccounts && !showBankSelection && (
        <button
          className={styles.additionalAccountLink}
          onClick={() => setShowBankSelection(true)}
        >
          Link an additional account +
        </button>
      )}
      {shouldShowLinkOpenBankingSplitTest && (
        <div className={styles.container}>
          {view === onlineBankSelection.BANK_LIST && (
            <>
              <BankSelectionStep onBankSelect={handleBankSelect} />
              <div className={styles.helpLinkContainer}>
                <Link href="#" className={styles.helpLink}>
                  Don’t know your login and need help linking your account?
                  <IconAngleRight className={styles.helpLinkIcon} />
                </Link>
              </div>
            </>
          )}
          {view === onlineBankSelection.BANK_CONNECTION && selectedBank && (
            <BankConnectionStep
              isOpen={true}
              onClickBack={handleBackClick}
              handleCloseWithCallback={handleClose}
              selectedBank={selectedBank}
              bankAuthURL={bankAuthUrl ?? ''}
              bankUrlError={isError}
            />
          )}
        </div>
      )}
    </>
  );
};

export default LinkBankAccount;
